var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from 'react';
import hoistStatics from 'hoist-non-react-statics';
import { BreakpointsContext } from './BreakpointsContext';
/**
 * HOC for providing breakpoints as props
 * Needs provider for `BreakpointsProps`
 */
export function withBreakpoints(Component) {
    function WrapperComponent(props) {
        var contextProps = useContext(BreakpointsContext);
        return _jsx(Component, __assign({}, contextProps, props), void 0);
    }
    // copy displayname of wrapped component
    WrapperComponent.displayName = "withBreakpoints(".concat(Component.displayName || Component.name, ")");
    // copy non-react static properties on the new component
    return hoistStatics(WrapperComponent, Component);
}
//# sourceMappingURL=withBreakpoints.js.map